import { forwardRef } from "react";
import { Button, Modal } from "react-daisyui";
import { IconX } from "@tabler/icons-react";
import { Heading } from "src/core/components/Heading";
import { SanitisedHtml } from "src/core/components/SanitisedHtml";
import { DateDisplay } from "src/core/components/data/DateDisplay";
import { usePrivacyPolicy } from "src/core/church/useChurchTexts";

interface Props {
    /** Fetches the policy only once the dialog has been opened */
    opened: boolean;
}

export const PrivacyPolicyDialog = forwardRef<HTMLDialogElement, Props>(({ opened }, ref) => {
    const { policy, error } = usePrivacyPolicy(opened);

    return (
        <Modal ref={ref} className="text-left" responsive>
            <Modal.Body>
                <form method="dialog">
                    <Modal.Header className="flex">
                        <Heading level="h4" className="grow">
                            Privacy policy
                        </Heading>

                        <Button startIcon={<IconX />} color="ghost" size="sm">
                            <span className="hidden">Close</span>
                        </Button>
                    </Modal.Header>

                    {policy ? (
                        <>
                            <p className="text-sm opacity-75 mb-4">
                                Last updated <DateDisplay date={policy.publishedAt} format="LONG" />
                            </p>

                            <SanitisedHtml html={policy.body} className="prose overflow-auto" />
                        </>
                    ) : error ? (
                        <p>There was an error loading the privacy policy. Try again, or contact the church for help.</p>
                    ) : (
                        <span className="loading loading-spinner" />
                    )}

                    <Modal.Actions>
                        <Button formMethod="dialog">Close</Button>
                    </Modal.Actions>
                </form>
            </Modal.Body>
        </Modal>
    );
});
